module.exports = __webpack_public_path__ + "static/img/1_3_1.2f4ecc6c.jpg";